export default __webpack_public_path__ + "static/icon-30-3-f6a5435b27f6ebf0279df639d82feaf2.png";